import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKeys } from '@/shared/hooks/queries/queryKeys'

import { createSoapSet, deleteSoapSet, updateSoapSet } from '../apis/masters'
import { type SoapSetInput } from '../types/masters'

// 定型文は**店舗の共有資産**なので、1 件直すと同じ店舗の全員に効く。
// invalidate は前方一致 1 本 (queryKeys.soapMasters.all) で足りる。

export const useCreateSoapSetMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: SoapSetInput) => createSoapSet(input),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: queryKeys.soapMasters.all }),
  })
}

export const useUpdateSoapSetMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: SoapSetInput }) =>
      updateSoapSet(id, input),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: queryKeys.soapMasters.all }),
  })
}

export const useDeleteSoapSetMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteSoapSet(id),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: queryKeys.soapMasters.all }),
  })
}
